import Vue from 'vue'
import vueResource from 'vue-resource'
import axios from 'axios'
import VueAxios from 'vue-axios'
import qs from 'qs'
import basePath from './basePath'

Vue.use(vueResource)
Vue.use(VueAxios, axios)

// axios
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
axios.interceptors.request.use(config => {
	if (config.url.indexOf(basePath) < 0) {
		config.url = `${basePath}${config.url}`
	}

	if (
		config.method === 'post' &&
		config.data &&
		config.data.constructor !== URLSearchParams
	) {
		// 之前在每个请求的地方使用了URLSearchParams 现在在这里统一处理
		// 如果请求方法为post并且没有经过URLSearchParams转换 使用qs转换
		config.data = qs.stringify(config.data)
	}
	return config
}, error => {
	return Promise.reject(error)
})

// vueResource
Vue.http.interceptors.push((request, next) => {
	if (request.url.indexOf(basePath) < 0) {
		request.url = `${basePath}${request.url}`
	}
	// continue to next interceptor
	next()
})


// WEBPACK FOOTER //
// ./src/api/index.js